import ShareableLinkFile from './ShareableLinkFile.component';

export default ShareableLinkFile;